import script from "./VehicleCancelDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleCancelDialog.vue?vue&type=script&setup=true&lang=js"

import "./VehicleCancelDialog.vue?vue&type=style&index=0&id=49272d5a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49272d5a"]])

export default __exports__